(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('SessionFactory', session);

	session.$inject = ['$q', '$http', '$injector', '$rootScope', 'ErrorFactory'];

	function session($q, $http, $injector, $rootScope, ErrorFactory) {

		var lang = "en";
		var sessionId = "";

		var sessionFactory = {
			getCurrentSession: getCurrentSession,
			createSession: createSession,
			updateCurrentSession: updateCurrentSession,
			retrieveCurrentSession: retrieveCurrentSession,
			deleteCurrentSession: deleteCurrentSession,
			session: {},
			sessionId: sessionId
		};

		return sessionFactory;

		// getCurrentSession - create session id
		function getCurrentSession() {
			if (sessionStorage.getItem('lang') !== incoming_lang) sessionStorage.removeItem('sid');
			if (sessionStorage.getItem('sidTimeout') && sessionStorage.getItem('sidTimeout') < new Date().getTime()) sessionStorage.removeItem('sid');
			sessionFactory.sessionId = sessionStorage.getItem('sid');
			if (!sessionFactory.sessionId) {
				ErrorFactory.timeout();
			}
			$injector.get('DataFactory').appData.applicant.sessionId = sessionFactory.sessionId;
			return sessionFactory.sessionId;
		};

		function createSession(model) {
			model.lang = incoming_lang;
			if (env == "DEV") {
				console.log("createSession", model);
			}
			model = JSON.stringify(model);
			var reqDataString = JSON.stringify({
				'data': model,
			});
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + "api/session/createsession",
				data: reqDataString
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					sessionFactory.sessionId = data.result_content.session_id;
					$injector.get('DataFactory').appData.applicant.sessionId = sessionFactory.sessionId;
					sessionStorage.setItem('lang', incoming_lang);
					sessionStorage.setItem('sid', sessionFactory.sessionId);
					sessionStorage.setItem('sidTimeout', new Date().getTime() + (19 * 60000));

					var sessionData = JSON.parse(model);
					sessionData.appState = $injector.get('DataFactory').appData.applicant.appState;
					$injector.get('DataFactory').appData.applicant = sessionData;
					deferred.resolve(sessionData);
				}
				else {
					ErrorFactory.errorPage(data['result_code'], "en", "Session create failed with response code error", data['result_content']);
					$rootScope.ga.errors.sessionError(data['result_code'], "Session create failed with response code error");
				}
			}, function (httpError) {
				if (httpError.status) {
					ErrorFactory.errorPage("SCE-" + httpError.status, "en", "Session create failed", "Session create failed with http status code error");
				}
				else {
					ErrorFactory.errorPage("SCU", "en", "Session create failed", "Session create failed with unexpected error");
				}
				deferred.reject(httpError)
			})
			return deferred.promise;
		}

		// retrieveCurrentSession - retrieve session data with id
		function retrieveCurrentSession() {
			var sid = getCurrentSession();
			if (!sid) return $q.reject();
			var reqDataString = JSON.stringify({
				'session_id': sid,
			});
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + "api/session/retrievesession",
				data: reqDataString
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] === "0") {
					try {
						var result_content = JSON.parse(data.result_content.data);
						if (env == "DEV") {
							console.log("retrieveCurrentSession", result_content);
						}
						if (!result_content.appState) result_content.appState = $injector.get('DataFactory').appData.applicant.appState;
						$injector.get('DataFactory').appData.applicant = result_content;
						deferred.resolve(data);

					} catch (e) {
						ErrorFactory.errorPage("SRN", 'en', 'Session retrieve data null', data['result_content']);
						$rootScope.ga.errors.sessionError("SRN", "Session retrieve data null");
						deferred.reject(data)
					}
				}
				else {
					ErrorFactory.errorPage(data['result_code'], "en", "Session retrieve failed with response code error", data['result_content']);
					$rootScope.ga.errors.sessionError(data['result_code'], "Session retrieve failed with response code error");
					deferred.reject(data['result_code'])
				}
			}, function (httpError) {
				if (httpError.status) {
					ErrorFactory.errorPage("SRE-" + httpError.status, "en", "Session retrieve failed", "Session retrieve failed with http status code error");
				}
				else {
					ErrorFactory.errorPage("SRU", "en", "Session retrieve failed", "Session retrieve failed with unexpected error");
				}
				deferred.reject(httpError)
			})
			return deferred.promise;
		};

		// updateCurrentSession - update session with app data
		function updateCurrentSession(appData) {
			var sid = getCurrentSession();
			if (!sid) return $q.reject();
			var reqDataString = JSON.stringify({
				'session_id': sid,
				'data': JSON.stringify(appData)
			});
			if (env == "DEV") {
				console.log("updateCurrentSession", appData);
			}
			var deferred = $q.defer();
			$http({
				method: 'POST',
				url: baseUrl + "api/session/updatesession",
				data: reqDataString
			}).then(function (response) {
				var data;
				try { data = JSON.parse(response.data); }
				catch (e) { data = response.data };
				if (data['result_code'] == "0") {
					deferred.resolve(data);
				}
				else if (data['result_code'] == '300') {
					ErrorFactory.timeout();
					$rootScope.ga.errors.timeout();
				}
				else {
					ErrorFactory.errorPage(data['result_code'], lang, "Session update failed with response code error", data['result_content']);
					$rootScope.ga.errors.sessionError(data['result_code'], "Session update failed with response code error");
				}

			}, function (httpError) {
				if (httpError.status) {
					ErrorFactory.errorPage("SUE-" + httpError.status, lang, "Session update failed with http status code error");
				}
				else {
					ErrorFactory.errorPage("SUU", lang, "Session update failed with unexpected error");
				}
			})
			return deferred.promise;
		};

		// deleteCurrentSession - delete session
		function deleteCurrentSession() {
			if (!sessionFactory.sessionId) sessionFactory.sessionId = sessionStorage.getItem('sid');
			sessionStorage.removeItem('sid');
			sessionStorage.removeItem('pid');
			sessionStorage.removeItem('asc');
			sessionStorage.removeItem('lang');
			sessionStorage.removeItem('sidTimeout')
			$rootScope.appCompleted = false;
			var deferred = $q.defer();
			if (sessionFactory.sessionId) {
				var reqDataString = JSON.stringify({
					'session_id': sessionFactory.sessionId
				});
				sessionFactory.sessionId = null;
				$http({
					method: 'POST',
					url: baseUrl + "api/session/deletesession",
					data: reqDataString
				}).then(function (response) {
					var data = JSON.parse(response.data);
					if (data['result_code'] == '0') {
						deferred.resolve(data);
					}
					else {
						deferred.reject(data);
					}
				}, function (httpError) {
					if (httpError.status) {
						//console.log("SDE-"+httpError.status, lang, "Session delete failed with http status code error");
					}
					else {
						//console.log("SDU", lang, "Session delete failed with unexpected error");
					}
				})
			} else {
				deferred.resolve();
			}
			return deferred.promise;
		};

	};

})();
